<template>
  <div class="trust-us-card">
    <div class="title">{{ title }}</div>
    <div class="subtitle">{{ subtitle }}</div>

    <IconBase :name="img" class="icon" />
  </div>
</template>

<script setup lang="ts">
import IconBase from '@/shared/icons/IconBase.vue';

defineProps<{
  title: string;
  subtitle: string;
  img: string;
}>();
</script>

<style scoped lang="scss">
.trust-us-card {
  position: relative;
  width: 100%;
  height: 270px;
  padding: 32px;
  background-color: var(--alias-color-background-accent-blue-lightest);
  border-radius: 16px;
}

.title,
.subtitle {
  position: relative;
  z-index: 1;
}

.title {
  @include typography.base-700-700-medium;
}

.subtitle {
  margin-top: 16px;

  @include typography.base-400-400-medium;
}

.icon {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
}
</style>
